import PropTypes from 'prop-types'
import React from "react"
import { Col, Row, Modal, ModalHeader, ModalBody, Input, Form, FormFeedback, Label } from "reactstrap";
import FileUpload from '../Upload/fileUpload';

const EditLoteModal = ({ show, onCloseClick }) => {
    
    // declare constants
    return (
        <Modal isOpen={show} toggle={onCloseClick} centered={true} backdrop={'static'}>
            <Form onSubmit={(e) => { 
                e.preventDefault(); 
                return false; 
                }}>
                <div className="modal-content">
                    <ModalHeader toggle={onCloseClick} tag="h4">                       
                        Editar publicações em lote
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col className="col-12">                                
                                <a href={process.env.REACT_APP_STORAGE_PATHMODELOEDIT} target="_blank" rel="noreferrer">Baixar planilha modelo</a>
                                <br/><br/>
                                <FileUpload container="publicacoes" tipoPublicacao="EdicaoLote"/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="text-end">
                                    <button type="submit" className="btn btn-success save-edit">Salvar</button>
                                </div>
                            </Col>
                        </Row>                            
                    </ModalBody>
                </div>
            </Form>
        </Modal>
    )
}

EditLoteModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
}

export default EditLoteModal
